module.exports = __webpack_public_path__ + "static/media/t-cross.2e979226.png";